import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { ElMessage } from 'element-plus';
import type { HttpResponse } from '../types';
import { useSettingsStore } from '../../stores';
import { bus } from '@sfvine/main-qiankun';
import { loginSuccess } from '../../stores/loginSuccess';

/**
 * 限制登录态失效提示，一次只提示一次
 */
let showNotLoginDialogFlag = false;

/**
 * 一般是同域名下其他系统登录了，导致该接口异常提示 403
 * 必须要用户手动清除缓存进行重新登录
 * 因此这里进行自动清缓存的操作，避免用户手动清除缓存
 * @param response 响应数据
 */
export const shouldLogoutOn403 = async (response: AxiosResponse<HttpResponse>) => {
  const { settings: { login, casConfig } } = useSettingsStore()
  const loginTypeRes = typeof login.type === 'function' ? await login.type() : login.type

  if (
    response.status !== 403 ||
    response.data.errorCode !== "09020213" ||
    loginTypeRes !== 'cas'
  ) {
    return
  }

  login?.onBeforeLogin?.(loginTypeRes);
  try {
    const res = await login?.onLogin?.(loginTypeRes, casConfig);
    loginSuccess.value = true
    login?.onLoginSuccess?.(loginTypeRes);
    bus.$emit('loginSuccess');

    // appKey 未发生变化说明 403 是正常现象，不用处理
    if (res?.appKey === casConfig.appKey) {
      return
    }
  } catch (e) {
    login?.onLoginFailed?.(loginTypeRes, e);
    bus.$emit('loginFailed', e);
  }

  try {
    await login.onLogout?.(loginTypeRes, casConfig)
    login.onAfterLogout?.(loginTypeRes)
    bus.$emit('logoutSuccess');

    const sensors = (window as any).sensorsDataAnalytic201505;
    sensors?.logout()
  } catch (e) {
    bus.$emit('logoutFailed', e);
  }
}

/**
 * 登录态拦截器
 */
export default {
  // 请求拦截器
  request: [
    (config: InternalAxiosRequestConfig) => {
      return config;
    },
    (error: any) => {
      // do something
      return Promise.reject(error);
    },
  ],
  // 响应拦截器
  response: [
    (response: AxiosResponse<HttpResponse>) => {
      const data = response.data;

      // todo 登录态失效,不同项目登录态失效的errorCode不同
      if (data.errorCode === '401' && !showNotLoginDialogFlag) {
        // 登录态失效
        showNotLoginDialogFlag = true;
        // 弹出登录框
        ElMessage.warning('登录态失效，请重新登录！');

        setTimeout(() => {
          // todo 跳转cas登录,不同项目处理方式不同，建议后端返回跳转cas的地址，通过target设置登录成功后的页面
          // @ts-ignore
          window.location.href = `${data.obj.urlToRedirectTo}?target=${window.location.href}`;
        }, 1000);
      }

      return response;
    },
    async (error: any) => {
      // 超出 2xx 范围的状态码都会触发该函数。
      // 对响应错误做点什么

      // 如果是 403 状态，判断是否需要重新登录
      await shouldLogoutOn403(error.response)

      return Promise.reject(error);
    },
  ],
};
